import React from "react";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen w-screen overflow-x-hidden bg-gradient-to-br from-[#020617] via-[#050816] to-black font-inter text-slate-100 flex flex-col">
      {/* Main content wrapper (keeps spacing around top/bottom) */}
      <div className="flex-1 w-full flex justify-center items-center pt-10 pb-24 md:pt-6 md:pb-24 box-border">
        {children}
      </div>

      {/* Floating pill footer */}
      <footer className="fixed bottom-4 left-1/2 -translate-x-1/2 rounded-full border border-white/10 bg-slate-900/80 px-4 py-1.5 text-[11px] text-slate-400 shadow-[0_0_12px_rgba(127,0,255,0.25)] backdrop-blur z-[1000]">
        © {new Date().getFullYear()} Dreamframe Studio. All rights reserved.
      </footer>
    </div>
  );
};

export default Layout;
